import { IconWrapper } from '../runtime';
export default IconWrapper('pic', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 10.75L5.54761 8.15164C6.10907 7.76748 6.85877 7.80928 7.37404 8.25348L13.8234 13.7978M3.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V3.25C14.25 2.42157 13.5784 1.75 12.75 1.75H3.25C2.42157 1.75 1.75 2.42157 1.75 3.25V12.75C1.75 13.5784 2.42157 14.25 3.25 14.25Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M12 5.25C12 5.94036 11.4404 6.5 10.75 6.5C10.0596 6.5 9.5 5.94036 9.5 5.25C9.5 4.55964 10.0596 4 10.75 4C11.4404 4 12 4.55964 12 5.25Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});